import { t } from "i18next"
import { Tag } from "@/components/ui/tag"
import { useChIsPatientInDataGuardQuery } from "@/modules/patients/information/consent/ch/services/useChIsPatientInDataGuardQuery"

const ChDataGuardPresenceTag = ({ patientId }: { patientId: string }) => {
  const isPatientInDataGuard = useChIsPatientInDataGuardQuery(patientId)

  return (
    <Tag
      data-testid="data-guard-presence-tag"
      type={isPatientInDataGuard ? "success" : "critical"}
      label={
        isPatientInDataGuard
          ? t("patient.information.consent.patientIsInDataGuard")
          : t("patient.information.consent.patientIsNotInDataGuard")
      }
    />
  )
}
export { ChDataGuardPresenceTag }
